import { Loader2 } from "lucide-react";

// ── Loading spinner helper ──────────────────────────────
export function LoadingSpinner({ text = "Loading" }: { text?: string }) {
  return (
    <div className="flex items-center justify-center py-12">
      <Loader2 className="size-5 text-indigo-600 animate-spin" />
      <span className="ml-3 text-sm text-muted-foreground">{text}</span>
    </div>
  );
}
